<video #videoPlayer width="100%" height="100%" controls></video>